module.exports = __webpack_public_path__ + "media/images/share/telegram-d61ccbcad52a2959ac2d234ee9662d95.svg";